/* eslint-disable @typescript-eslint/no-explicit-any */
import { decorators } from '@orange-marmalade/paginate-this'
import select from './selectors'
import controlListState from './controlListState'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function tabulateList<T extends React.ComponentType<any>>(ListComp: T) {
    return decorators.decorate(controlListState(ListComp), props =>
        select(props.paginator).tabulateList()
    )
}
